import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-environment-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './environment-banner.component.html',
  styleUrl: './environment-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentBadgeComponent {
  readonly exibirBanner = !environment.production;
  readonly mensagem = 'AMBIENTE DE TESTES';
}
